import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import config from '../config';
import Logo from './Logo';

const Pavebas = () => {
  const { t } = useContext(LanguageContext);
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <Logo className="logo--footer" />
          <strong>{config.name}</strong>
          <p>{config.addressLine}, {config.city}</p>
        </div>
        <div>
          <a href={`mailto:${config.email}`}>{config.email}</a>
          {config.phone && <p>{config.phone}</p>}
        </div>
        <div className="footer__links">
          <Link to="/projets">{t.nav.projects}</Link>
          <Link to="/about">{t.nav.about}</Link>
          <Link to="/contact">{t.nav.contact}</Link>
        </div>
      </div>
      <p className="footer__copy">© {new Date().getFullYear()} {config.name} — {t.footer.rights}</p>
    </footer>
  );
};

export default Pavebas;
